import { NotifyHelper } from "../../../helpers/toast";
import { objDmTrangThaiLeadDefine } from "../../action-types/crm-category/IDmTrangThaiLeadActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const dmTrangThaiLeadActions = {
    ...generateActions(objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD"),
    ...generateActionForKey(objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Lưu thành công")),
    ...generateActionForKey(objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Xóa thành công")),
    ...generateActionForKey(objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
